import { TranslocoService } from '@jsverse/transloco';
import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HxError } from 'hx-services';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class NotificationService {
  constructor(
    private nzNotification: NzNotificationService,
    private tr: TranslocoService
  ) { }

  public success(code: string, data?: any): void {
    this.nzNotification.success('', this.tr.translate(code, data));
  }

  public error(code: string, data?: any): void {
    this.nzNotification.error('', this.tr.translate(code, data));
  }

  public warning(code: string, data?: any): void {
    this.nzNotification.warning('', this.tr.translate(code, data));
  }

  public info(code: string, data?: any): void {
    this.nzNotification.info('', this.tr.translate(code, data));
  }

  handleError(err: any) {
    if (err instanceof HttpErrorResponse) {
      const error: HxError = err.error?.message ? err.error as HxError : {
        code: 577,
        id: '-',
        message: err.message,
        data: err.error,
      };
      if (error.message === 'requiredFields') {
        this.error('error.' + error.message);
      } else {
        this.error(error.message, error.data);
      }
    }
  }
}
